/* eslint-disable */
import { createI18n } from 'vue-i18n'
import en from '@/assets/locales/en.json'
import ko from '@/assets/locales/ko.json'
import ja from '@/assets/locales/ja.json'
import { detectInitialLocale, SUPPORTED_LOCALES } from '@/composables/localeDetect'

export const messages = {
  ko,
  en,
  ja,
}

export { SUPPORTED_LOCALES }

export const i18n = createI18n({
  legacy: false,
  locale: detectInitialLocale(),
  fallbackLocale: 'en',
  messages,
})

export default i18n
